import styled from "styled-components"
import { Flex, FlexProps } from "rebass"

const ModalCard = styled<FlexProps>(Flex)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: calc(100vh - 60px);
  overflow: auto;
  position: relative;
  z-index: 2;
  @media screen and (max-width: 481px) {
    max-height: 100vh;
  }
`

export default ModalCard
